import { MijnRoute } from '../../mijn-navigatie.model';

export const ACCOUNT: MijnRoute = {
    path: 'rekening',
    navigationEvent: 'toRekening',
    regex: /^\/rekening$/,
    webcomponent: 'mijn-rekening-webcomponent'
};
